import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { adminFetch } from "@/lib/adminApi";

const API = process.env.REACT_APP_BACKEND_URL;

export default function FiveDayFollowUpTest() {
  const { orderNumber, reportId } = useParams();
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const sendNow = async () => {
    setBusy(true);
    setResult("");
    setError("");
    try {
      const res = await adminFetch(`${API}/api/reports/${reportId}/five-day-follow-up?force=true`, { method: "POST" });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || `Request failed (HTTP ${res.status})`);
      setResult(`Five-day follow-up sent to ${data.to || "customer"}.`);
    } catch (err) {
      setError(err.message || "Five-day follow-up could not be sent.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ padding: 32, color: "#2A2540" }}>
      <Link to={`/admin/orders/${encodeURIComponent(orderNumber)}`} style={{ color: "#6A4FC0", fontWeight: 700 }}>Back to order</Link>
      <h1 style={{ marginTop: 20 }}>Five-Day Follow-Up Test</h1>
      <p>Order: <strong>{orderNumber}</strong></p>
      <p>Report ID: <strong>{reportId}</strong></p>
      <button
        type="button"
        onClick={sendNow}
        disabled={busy}
        style={{ marginTop: 12, padding: "12px 18px", borderRadius: 10, border: "1px solid #C9BFEE", background: "#F0ECFB", color: "#5B21B6", fontWeight: 800, cursor: busy ? "wait" : "pointer" }}
      >
        {busy ? "Sending..." : "Send Five-Day Follow-Up Now"}
      </button>
      {result && <div style={{ marginTop: 16, color: "#166534", fontWeight: 700 }}>{result}</div>}
      {error && <div style={{ marginTop: 16, color: "#991B1B", fontWeight: 700 }}>{error}</div>}
    </div>
  );
}
